
/**
 * HornDeliver wordmark — "Horn" in foreground color, "Deliver" in gold.
 *
 * The gold "Deliver" is the brand's signature accent: it ties the wordmark to
 * the gold semantic color used for money/price/premium value across the app,
 * and gives the otherwise-teal brand a warm, premium highlight.
 *
 * Use anywhere the app name is shown as text (topbar, landing header, footer,
 * auth screen, legal pages).
 */
export function BrandWordmark({
  className = "",
  goldClassName = "",
}: {
  className?: string;
  /** Override the gold "It" styling (e.g. to drop the gradient on tiny sizes). */
  goldClassName?: string;
}) {
  return (
    <span className={`font-bold tracking-tight ${className}`}>
      Horn
      <span className={`text-gold-gradient ${goldClassName}`}>Deliver</span>
    </span>
  );
}
